<template>
  <div class="card mb-4">
    <div class="card-header">
      <h2>Arbeidsongeschiktheid</h2>
    </div>
    <div class="card-body">
      <div v-for="(percentage, index) in percentages" :key="index" class="list-names">
        <p>{{ percentage.ziektepercentage }}% per {{ new Date(percentage.created_at).toLocaleDateString('nl-NL', {day: 'numeric', month: 'long', year: 'numeric'}) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
      percentages: Array
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/SicknessHistory.vue